import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'brand_acquisition-brandinboundapplication-action_unknown';

/**
 * Emits facebook event when a brand completes registration
 */
export function trackBrandAcquisitionBrandinboundapplication(
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent: 'BrandInboundApp',
    pixelCustomDataParams,
  });
}
